const constants = {
  defaultDateFormat: "DD/MM/YYYY",
  defaultDateTimeFormat: "DD/MM/YY HH:mm[H]",
  altDateTimeFormat: "DD/MM/YY HH:mm",
  orderBy: {
    asc: "asc",
    desc: "desc",
  },
  orderMode: {
    SERVIDOR: "SERVIDOR",
    LOCAL: "LOCAL",
  },
};

export const SUPPORT_URL =
  `https://prodapsuporte.zendesk.com/access/jwt?&return_to=${encodeURIComponent(
    "https://farmtellviews.zendesk.com/hc/pt-br",
  )}` as const;

export const DATE_PICKER_MASK = [
  /\d/,
  /\d/,
  "/",
  /\d/,
  /\d/,
  "/",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export default constants;
